import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/delete.png'


const _hoisted_1 = {
  key: 0,
  class: "selected-image-container"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src"]

import { ref, onMounted } from 'vue';
import { ImageDetails, ImageListing, ImageListingEvents } from './componentModel/ImageListContainerModel';
import { Popup, Button } from '../ts/components';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageListContainer',
  props: {
    images: {},
    allowDelete: { type: Boolean, default: false }
  },
  emits: ["update:images"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// #region Data
const showImagePopup = ref(false);
const fullImgName = ref('');
const imgSrc = ref<string | undefined>('');
const allImages = ref<ImageDetails[]>([]);
// #endregion Data

// #region Methods
const openFileImg = (file: ImageDetails) => {
  console.log(file);
  // Showing the popup
  showImagePopup.value = true;

  // Set the name
  fullImgName.value = file.filename;

  // Checking if the file is null or not
  if (file.file) {
    // Reading the file as data url to show in the full popup
    const reader = new FileReader();
    reader.onload = (ev: ProgressEvent<FileReader>) => {
      imgSrc.value = ev.target?.result as string | undefined;
    }
  
    reader.readAsDataURL(file.file);
  } else {
    imgSrc.value = `https://samuel-test.reeqzan.com/api/File/DownloadFile?file_uid=${file.uid}`;
  }
}
const deleteImgClicked = (idx: number) => {
  allImages.value.splice(idx, 1);
  emit('update:images', allImages.value);
}
// #endregion Methods

// #region Lifecycle
onMounted(() => {
  allImages.value = props.images;
})
// #endregion Lifecycle

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (allImages.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allImages.value, (img, imgIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: imgIdx,
              class: "selected-image-details"
            }, [
              _createElementVNode("div", {
                class: "name",
                onClick: ($event: any) => (openFileImg(img))
              }, _toDisplayString(img.filename), 9, _hoisted_2),
              (_ctx.allowDelete)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "delete-icon",
                    src: _imports_0,
                    alt: "delete",
                    onClick: ($event: any) => (deleteImgClicked(imgIdx))
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, "No image available")),
    _createVNode(_unref(Popup), {
      show: showImagePopup.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showImagePopup).value = $event))
    }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(fullImgName.value), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("img", {
          class: "full-image-popup",
          src: imgSrc.value,
          alt: ""
        }, null, 8, _hoisted_5)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          theme: "danger",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showImagePopup.value = false))
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Close")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})